export default __webpack_public_path__ + "static/media/mic.92d3a2f2.png";